import styled from 'styled-components';

import colors from '../../../chat/styles/colors';

const PageContainer = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`;

const ContentContainer = styled.div`
  flex: 2;
  height: 100%;
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors.shades.gamma7};
`;

export {
  PageContainer,
  ContentContainer,
};
